import { makeStyles } from '@material-ui/core';
import { Palette } from '@jda/lui-common-component-library';

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    padding: theme.spacing(2),
    borderBottom: '1px solid'
  },
  progress: {
    color: theme.palette.background.paper
  },
  priorityBarSettings: {
    position: 'relative',
    height: theme.spacing(4),
    width: theme.spacing(0.25)
  },
  highlight: {
    color: '#047ABC',
    '& > *': {
      fill: '#047ABC'
    }
  },
  pagination: {
    float: 'right'
  },
  paginationBar: {
    backgroundColor: theme.palette.background.paper,
    borderBottomLeftRadius: theme.spacing(0.5),
    borderBottomRightRadius: theme.spacing(0.5)
  },
  root: {
    width: '100%',
    whiteSpace: 'nowrap'
  },
  drawer: {
    width: 300,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    '& > *': {
      boxShadow: '1px 1px 10px 0px rgba(0, 0, 0, 0.3)'
    }
  },
  drawerOpen: {
    overflowX: 'hidden',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: 300,
    transition: theme.transitions.create(['width', 'height'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create(['width', 'height'], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    width: 0
  },
  dialog: {
    padding: theme.spacing(0),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: 0,
    borderBottom: `1px solid ${Palette.colors.grey['300']}`
  },
  button: {
    color: theme.palette.background.paper,
    borderColor: theme.palette.background.paper,
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    '&:disabled': {
      color: theme.palette.background.paper,
      borderColor: theme.palette.background.paper,
      opacity: '0.5'
    }
  },
  toolbar: {
    color: theme.palette.background.paper,
    background: 'transparent',
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    marginBottom: theme.spacing(2)
  },
  toggledToolbar: {
    backgroundColor: theme.palette.background.paper,
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(0.75)
  },
  box: {
    height: theme.spacing(0.5)
  },
  chip: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    fontSize: theme.spacing(1.75),
    color: theme.palette.text.primary,
    backgroundColor: Palette.colors.byBlue['50'],
    border: `1px solid ${Palette.colors.byBlue['800']}`,
    textOverflow: 'ellipsis',
    maxWidth: theme.spacing(21.25)
  },
  typographyLabel: {
    fontSize: theme.spacing(2),
    fontWeight: 'bold',
    color: theme.palette.text.primary
  },
  tooltipContent: {
    maxWidth: theme.spacing(25),
    wordWrap: 'break-word'
  },
  additionalChips: {
    cursor: 'pointer',
    padding: theme.spacing(1),
    color: Palette.colors.byBlue['800'],
    fontSize: theme.spacing(1.75),
    paddingTop: theme.spacing(1.5),
    paddingRight: theme.spacing(1)
  },
  clearAllButton: {
    cursor: 'pointer',
    padding: theme.spacing(1),
    color: Palette.colors.byBlue['800'],
    fontSize: theme.spacing(1.75),
    paddingTop: theme.spacing(1.5),
    paddingRight: theme.spacing(2)
  },
  iconButton: {
    float: 'right',
    marginRight: theme.spacing(0.5)
  },
  dialogContent: {
    padding: theme.spacing(0),
    backgroundColor: Palette.colors.cornflower['50']
  },
  content: {
    padding: theme.spacing(2)
  },
  filterToolbar: {
    paddingRight: theme.spacing(0),
    paddingLeft: theme.spacing(2),
    minHeight: theme.spacing(6.25),
    maxHeight: theme.spacing(6.25),
    borderBottom: `1px solid ${Palette.colors.grey['200']}`
  },
  chipIcon: {
    marginLeft: theme.spacing(0.25)
  },
  downloadButton: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5)
  },
  toolbarButton: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    fontWeight: 'bold',
    border: `1.5px solid ${Palette.colors.byBlue['800']}`,
    '&:hover': {
      border: `1.5px solid ${Palette.colors.byBlue['800']}`
    }
  },
  buttonIT: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    '&:disabled': {
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      opacity: '0.5'
    }
  },
  summaryObj: {
    display: 'inline-block !important',
    padding: theme.spacing(1),
    width: theme.spacing(12)
  },
  summaryDiv: {
    borderRadius: theme.spacing(0.5),
    border: '1px solid',
    borderColor: theme.palette.divider,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  totalObj: {
    display: 'inline-block !important',
    padding: theme.spacing(1),
    width: theme.spacing(12),
    backgroundColor: theme.palette.background.default,
    borderTopRightRadius: theme.spacing(0.5),
    borderBottomRightRadius: theme.spacing(0.5)
  },
  tooltipContents: {
    padding: theme.spacing(0.5)
  },
  closeIcon: {
    cursor: 'pointer',
    color: theme.palette.background.paper,
    float: 'right',
    marginLeft: theme.spacing(0.5),
    paddingLeft: theme.spacing(1)
  },
  tooltipTitle: {
    whiteSpace: 'pre-line',
    maxWidth: theme.spacing(25),
    wordWrap: 'break-word'
  },
  gridContainer: {
    paddingBottom: theme.spacing(0.75),
    borderBottom: '1px solid rgba(255,255,255,0.3)'
  },
  insideToolbar: {
    minHeight: theme.spacing(7),
    maxHeight: theme.spacing(7)
  },
  showingItems: {
    fontSize: theme.spacing(2),
    fontWeight: 'bold'
  },
  table: {
    '& tbody>.MuiTableRow-root:hover': {
      background: Palette.colors.grey['100']
    },
    '& tbody>tr:nth-child(even)': {
      background: `${theme.palette.background.default}88`
    }
  },
  input: {
    paddingBottom: 0
  }
}));
